<div class="card pv-card border-0 overflow-hidden" data-bs-theme="dark">
    <div class="card-body p-4">
        <div class="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center gap-3 mb-4">
            <div class="d-flex align-items-center gap-3">
                <span class="p-3 fs-4 bg-warning-subtle text-warning border border-warning-subtle rounded-4 d-flex align-items-center justify-content-center flex-shrink-0">
                    <i class="bi bi-people-fill"></i>
                </span>
                <div>
                    <h3 class="fw-bold text-white mb-1">User Management</h3>
                    <p class="text-body-secondary mb-0">Add users, update their roles, and manage account access.</p>
                </div>
            </div>

            <button
                type="button"
                class="btn btn-warning fw-semibold btn-sm rounded-3 text-xs d-inline-flex align-items-center justify-content-center gap-1 align-self-start align-self-lg-center"
                @click="$emit('open-add-user')"
            >
                <i class="bi bi-person-plus-fill"></i>
                <span>Add user</span>
            </button>
        </div>

        <div class="row g-3">
            <div v-for="stat in stats" :key="stat.label" class="col-sm-4">
                <div class="bg-black bg-opacity-25 border border-secondary-subtle rounded-4 p-3 d-flex align-items-center gap-3 h-100">
                    <span class="rounded-3 d-flex align-items-center justify-content-center flex-shrink-0 p-2 fs-5" :class="stat.tone">
                        <i class="bi" :class="stat.icon"></i>
                    </span>
                    <div>
                        <div class="fs-4 fw-bold text-white lh-1 mb-1">{{ stat.value }}</div>
                        <small class="text-body-secondary text-uppercase fw-semibold">{{ stat.label }}</small>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
